export default __webpack_public_path__ + "static/media/app-store.814cb2b1.svg";